module.exports = __webpack_public_path__ + "static/media/5.bdd98468.jpg";